// Real event assets (locally hosted in /public/photos)
export const POSTER_2 = "/photos/poster-02.jpg";

export const SAMVEDNA_PHOTOS = [
    { src: "/photos/Samvedna-1.jpg", caption: "Samvedna · On stage", meta: "Noida · Sep 2025", aspect: "aspect-[3/2]" },
    { src: "/photos/Samvedna-2.jpg", caption: "Samvedna · The room", meta: "Noida · Sep 2025", aspect: "aspect-[3/2]" },
    { src: "/photos/Samvedna-3.jpg", caption: "Samvedna · Workshop floor", meta: "Noida · Sep 2025", aspect: "aspect-[3/2]" },
    { src: "/photos/Samvedna-4.jpg", caption: "Samvedna · In conversation", meta: "Noida · Sep 2025", aspect: "aspect-[3/2]" },
    { src: "/photos/Samvedna-5.jpg", caption: "Samvedna · Closing", meta: "Noida · Sep 2025", aspect: "aspect-[3/2]" },
];

export const NO_AGENDA_1_PHOTOS = [
    { src: "/photos/NoAgendaMeetup-1.jpg", caption: "No Agenda 1.0 · The talk", meta: "Gurugram · Aug 2025", aspect: "aspect-[16/9]" },
    { src: "/photos/NoAgendaMeetup-2.jpg", caption: "No Agenda 1.0 · The crowd", meta: "Gurugram · Aug 2025", aspect: "aspect-[4/3]" },
    { src: "/photos/NoAgendaMeetup-3.jpg", caption: "No Agenda 1.0 · Q&A", meta: "Gurugram · Aug 2025", aspect: "aspect-[4/3]" },
    { src: "/photos/NoAgendaMeetup-4.jpg", caption: "No Agenda 1.0 · Break", meta: "Gurugram · Aug 2025", aspect: "aspect-[4/3]" },
    { src: "/photos/NoAgendaMeetup-5.jpg", caption: "No Agenda 1.0 · Hands up", meta: "Gurugram · Aug 2025", aspect: "aspect-[4/3]" },
    { src: "/photos/NoAgendaMeetup-6.jpg", caption: "No Agenda 1.0 · Together", meta: "Gurugram · Aug 2025", aspect: "aspect-[4/3]" },
];

// Used for the event card hero images
export const SAMVEDNA_HERO = "/photos/Samvedna-1.jpg";
export const NO_AGENDA_1_HERO = "/photos/NoAgendaMeetup-1.jpg";

// Combined for gallery (mixed masonry)
export const GALLERY_PHOTOS = [
    SAMVEDNA_PHOTOS[0],
    NO_AGENDA_1_PHOTOS[1],
    SAMVEDNA_PHOTOS[2],
    NO_AGENDA_1_PHOTOS[0],
    SAMVEDNA_PHOTOS[3],
    NO_AGENDA_1_PHOTOS[3],
    SAMVEDNA_PHOTOS[1],
    NO_AGENDA_1_PHOTOS[2],
    SAMVEDNA_PHOTOS[4],
    NO_AGENDA_1_PHOTOS[5],
    NO_AGENDA_1_PHOTOS[4],
];
